module.exports = __webpack_public_path__ + "static/media/firstam_karla_mcmillen.52052405.jpg";